import React, { useState, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import diamond from '../../assets/diamond.png'
import settingsImg from '../../assets/settingsImg.png'
import colors from '../../styles/colors'
import { useNavigate } from 'react-router-dom'
import UserImpact from '../shared/UserImpact'
import EquivalentImpact from './EquivalentImpact'
import arrow from '../../assets/swap.png'
import orangeLogo from '../../assets/orangeLogo.png'

const StyledHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100vw;
    min-height: 180px;
    box-shadow: 0 -10px 90px #00000099;
    padding: 10px 50vw;
`
const StyledLoginButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.second};
    color: white;
    font-weight: bold;
    width: 140px;
    padding: 15px;
    border-radius: 50px;
    &:hover {
        cursor: pointer;
        filter: brightness(0.9);
    }
`
const StyledSignupButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.fifth};
    color: white;
    font-weight: bold;
    width: 140px;
    padding: 12px;
    border-radius: 50px;
    &:hover {
        cursor: pointer;
        filter: brightness(0.9);
    }
`

const StyledUserSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 150px;
    margin: 0 80px 0 0;
    gap: 10px;
`

const StyledUserPicture = styled.div`
    display: flex;
    position: relative;
    height: 150px;
    border-radius: 100px;
    transition: all 0.3s ease-in-out;
    &:hover {
        filter: brightness(0.8);
    }
`

// const StyledUserPictureSettings = styled.img`
//     position: absolute;
//     top: 5px;
//     left: -80px;
//     width: 40px;
//     object-fit: cover;
//     aspect-ratio: 1/1;
//     background-color: white;
//     border-radius: 50px;
//     padding: 8px;
//     box-shadow: 0 0 15px grey;
//     &:hover {
//         cursor: pointer;
//     }
// `

const StyledUserPictureImg = styled.img`
    position: absolute;
    top: 0;
    right: -75px;
    border-radius: 150px;
    height: 150px;
    width: 150px;
    object-fit: cover;
    box-shadow: 0 0 50px #00000065;
    &:hover {
        cursor: pointer;
    }
`
const StyledUserPicturePremium = styled.img`
    position: absolute;
    top: 5px;
    right: -80px;
    width: 40px;
    object-fit: cover;
    aspect-ratio: 1/1;
    background-color: white;
    border-radius: 50px;
    padding: 8px;
    box-shadow: 0 0 15px grey;
`

const StyledHeaderRight = styled.div`
    display: flex;
`

const StyledUserImpact = styled(UserImpact)`
    display: flex;
    width: 100%;
    align-items: center;
    justify-items: center;
    & img {
        width: 30px;
        margin: 5px;
    }
`
const StyledSwap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end;
    margin: 0 35px 15px 35px;
`
const StyledSwapOrangeLogo = styled.img`
    width: 60px;
    padding-bottom: 5px;
`
const swapArrowAnimation = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(180deg);
    }
`
const StyledSwapArrow = styled.img`
    position: absolute;
    width: 75px;
    &.swap {
        animation: ${swapArrowAnimation} 2s ease-in-out;
    }
`
const StyledEquivalentImpact = styled(EquivalentImpact)`
    display: flex;
    width: 100%;
    align-items: center;
    justify-items: center;
    & img {
        width: 30px;
        margin: 5px;
    }
`

const Header = ({
    setIsSidebarOpen,
    setIsSignupVisible,
    setIsLoginVisible,
    isLoadingUserInfo,
    isErrorUserInfo,
    userInfo,
}) => {
    const [isSwapping, setIsSwapping] = useState(false)
    const navigate = useNavigate() // Initialiser le hook useNavigate

    useEffect(() => {
        const interval = setInterval(() => {
            // Ajout de la classe pour déclencher l'animation
            setIsSwapping(true)

            // Retirer la classe
            setTimeout(() => setIsSwapping(false), 2000)
        }, 10000) // Lancer l'animation toutes les X seconds

        // Nettoyage lors du démontage du composant
        return () => clearInterval(interval)
    }, [])

    const handleOnClickLogin = () => {
        setIsLoginVisible(true)
    }
    const handleOnClickSignup = () => {
        setIsSignupVisible(true)
    }

    return (
        <StyledHeader>
            {!userInfo ? (
                <StyledUserSection>
                    <StyledLoginButton onClick={handleOnClickLogin}>
                        Se connecter
                    </StyledLoginButton>
                    <StyledSignupButton onClick={handleOnClickSignup}>
                        Signup
                    </StyledSignupButton>
                </StyledUserSection>
            ) : (
                // If the user has a valid auth
                <StyledUserSection>
                    <StyledUserPicture>
                        <StyledUserPictureImg
                            src={userInfo.pictureUrl}
                            alt="User"
                            onClick={() => navigate('/PrivateProfile')}
                        />
                        {userInfo.premium && (
                            <StyledUserPicturePremium
                                src={diamond}
                                alt="premium"
                            />
                        )}
                        {/* <StyledUserPictureSettings
                            src={settingsImg}
                            alt="Ouvrir settings"
                            onClick={() => setIsSidebarOpen((prev) => !prev)}
                        /> */}
                    </StyledUserPicture>
                </StyledUserSection>
            )}
            <StyledHeaderRight>
                <StyledUserImpact userInfo={userInfo} />
                <StyledSwap>
                    <StyledSwapOrangeLogo src={orangeLogo} alt="swape arrows" />
                    <StyledSwapArrow
                        src={arrow}
                        alt="swape arrows"
                        className={`swap-arrow ${isSwapping ? 'swap' : ''}`}
                    />
                </StyledSwap>
                <StyledEquivalentImpact
                    userInfo={userInfo}
                    isSwapping={isSwapping}
                />
            </StyledHeaderRight>
        </StyledHeader>
    )
}

export default Header
